import actionCreatorFactory from 'typescript-fsa'
import { GetReferralSummaryParams, ReferralSummary } from '../../api/referral/types'
import { APIError } from '../../api/types'

const actionCreator = actionCreatorFactory('@@uplive/referral')

export const getReferralSummaryActions = actionCreator.async<GetReferralSummaryParams, ReferralSummary, APIError>(
	'getReferralSummary'
)
